<template>
  <div class="tf">
    <div class="tf-banner">
      <div class="container">
        <h1 class="tf-banner__title">TF</h1>
      </div>
    </div>
    <div class="tf-body">
      <div class="container">
        <div class="tf-panel">
          <h3 class="tf-title">Brief introduction</h3>
          <p class="tf-desc">
            Below are all the transcription factors for the genus
            Actinobacteria, click on the dots to view the information.
          </p>
          <div class="tf-charts">
            <div class="tf-charts__tree">
              <tree-chart-two
                ref="TreeChartRef"
                :data="treeData"
                @finished="handleTreeChartRendered"
                @chart-click="handleChartClick"
                @chart-click-leaf="handleChartClickLeaf"
              ></tree-chart-two>
            </div>
            <div class="tf-charts__sunburst">
              <sunburst-chart-round
                ref="SunburstChartRef"
                :data="sunburstData"
                @chart-dblclick="handleChartDblClick"
              ></sunburst-chart-round>
            </div>
          </div>
        </div>

        <div class="tf-panel">
          <h3 class="tf-title__second">
            Basic Domains group{{ currentName.length > 0 ? " - " : ""
            }}{{ currentName }}
          </h3>
          <el-table
            :data="tableData"
            border
            class="tf-table"
            height="300"
            style="width: 100%"
          >
            <el-table-column label="Ensembl ID" prop="ensemblId" width="180">
            </el-table-column>
            <el-table-column label="Gene ID" prop="geneId" width="180">
            </el-table-column>
            <!-- <el-table-column label="Gene Symbol" prop="geneSymbol">
            </el-table-column> -->
            <el-table-column label="Family" prop="tfFamilies">
            </el-table-column>
            <el-table-column label="Species" min-width="140" prop="species">
            </el-table-column>
            <el-table-column align="center" label="Details">
              <template v-slot="{ row }">
                <el-button type="text" @click="handleView(row)">
                  View
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="tf-pagination">
            <el-pagination
              :current-page.sync="pageInfo.page"
              :page-size="pageInfo.pageSize"
              :total="pageInfo.total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeChartTwo from "@/components/charts/TreeChartTwo.vue";
import SunburstChartRound from "@/components/charts/SunburstChartRound.vue";
import { categoriesByFamily, tfByCategoryAndFamily, tfSearch } from "@/api/tf";
import { px2rem } from "@/utils/rem";
import loadingMixins from "@/mixins/loadingMixins";
import { cloneDeep } from "lodash-es";

export default {
  name: "SpeciesView",
  mixins: [loadingMixins],
  components: { SunburstChartRound, TreeChartTwo },
  data() {
    return {
      activeName: "TF",
      treeData: [],
      sunburstData: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      currentName: "",
      searchOption: { name: "", index: 0, treeAncestors: [] },
      tableLoading: false,
      hasInitSunburstData: false,
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    startLoading() {
      this.loadingMixins__startLoading().then(() => {
        this.tableLoading = true;
      });
    },
    endLoading() {
      this.loadingMixins__endLoading().then(() => {
        this.tableLoading = false;
      });
    },
    initData() {
      this.initTreeData();
      this.initTableData();
    },
    handleTreeChartRendered() {
      if (!this.hasInitSunburstData) {
        this.initSunburstData();
        this.hasInitSunburstData = true;
      }
    },
    initTreeData() {
      tfByCategoryAndFamily("TF").then((res) => {
        setTimeout(() => {
          this.treeData = [res.data];
          this.$refs.TreeChartRef.setData(this.treeData);
        });
      });
    },
    // 初始化旭日图数据
    initSunburstData() {
      categoriesByFamily("TF").then((res) => {
        function recursion(item) {
          item.label = {
            rotate: "tangential",
            fontSize: px2rem(10),
          };
          if (item.children) {
            item.children = item.children.map((itemChild) => {
              return recursion(itemChild);
            });
          }
          return item;
        }
        setTimeout(() => {
          this.sunburstData = res.data.map((item) => {
            return recursion(item);
          });
          this.$refs.SunburstChartRef.setData(this.sunburstData);
        });
      });
    },
    initTableData() {
      this.startLoading();
      tfSearch({
        page: this.pageInfo.page,
        limit: this.pageInfo.pageSize,
        data: this.createData(0, [{ name: "TF", level: 2 }]),
      })
        .then((res) => {
          this.tableData = res.data;
          this.pageInfo.total = res.count;
        })
        .finally(() => {
          this.endLoading();
        });
    },
    handleTabClick() {
      if (this.activeName !== "TF") {
        this.$router.push({
          name: this.activeName,
        });
      }
    },
    createData(index, treeAncestors) {
      const data = {
        tfName: "",
        tfType: "",
        type: "",
        ensemblId: "",
        geneId: "",
        transcriptId: "",
        proteinId: "",
        uniprotId: "",
        sourceId: "",
        tfFamilies: "",
        tfCategories: "",
      };
      treeAncestors.forEach((item) => {
        const name = item.name;
        const level = item.level;
        if (level === 2) {
          data.tfType = name;
        }
        // if (level === 3) {
        //   data.tfCategories = name;
        // }
        if (level === 3) {
          data.tfFamilies = name;
        }
        if (level === 4) {
          data.tfName = name;
        }
      });
      return data;
    },
    handleChartClick({ name, index, treeAncestors }) {
      this.searchOption = { name, index, treeAncestors };
      this.startLoading();
      this.currentName = name;
      this.tableData = [];
      tfSearch({
        page: this.pageInfo.page,
        limit: this.pageInfo.pageSize,
        data: this.createData(index, treeAncestors),
      })
        .then((res) => {
          this.tableData = res.data;
          this.pageInfo.total = res.count;
        })
        .finally(() => {
          this.endLoading();
        });
    },
    handleChartClickLeaf({ index, treeAncestors }) {
      tfSearch({
        page: 1,
        limit: 1,
        data: this.createData(index, treeAncestors),
      }).then((res) => {
        const tfItem = res.data[0];
        if (tfItem) {
          const { href } = this.$router.resolve({
            path: "/detail",
            query: {
              id: tfItem.id,
            },
          });
          window.open(href);
        }
      });
    },
    handleChartDblClick({ level, name }) {
      setTimeout(() => {
        this.$refs.TreeChartRef.setData(
          this.expandNodeByNameAndLevel(cloneDeep(this.treeData), level, name)
        );
      }, 500);
    },
    // 展开树状图某个节点
    expandNodeByNameAndLevel(data, targetLevel, targetName, currentLevel = 1) {
      if (!Array.isArray(data)) return [];

      // 如果当前层级是目标层级
      if (currentLevel === targetLevel) {
        return data.map((node) => {
          return {
            ...node,
            collapsed: node.name !== targetName,
          };
        });
      }
      // 如果还没到目标层级，继续递归 children
      return data.map((node) => {
        if (node.children && currentLevel < targetLevel) {
          return {
            ...node,
            children: this.expandNodeByNameAndLevel(
              node.children,
              targetLevel,
              targetName,
              currentLevel + 1
            ),
          };
        }
        return node;
      });
    },
    handleView(row) {
      const { href } = this.$router.resolve({
        path: "/detail",
        query: {
          id: row.id,
        },
      });
      window.open(href);
    },
    handleCurrentChange() {
      this.handleChartClick(this.searchOption);
    },
  },
};
</script>

<style lang="scss" scoped>
.tf {
  padding-bottom: px2rem(100);
  .tf-banner {
    display: flex;
    align-items: center;
    height: px2rem(300);
    background-image: url("~@/assets/tf/banner.webp");
    background-size: cover;
    background-position: bottom center;

    .tf-banner__title {
      color: #fff;
    }
  }

  .tf-body {
    padding-top: px2rem(30);
  }

  .tf-tabs {
    margin-bottom: px2rem(80);
  }

  .tf-panel {
    border: 1px solid #eee;
    padding: px2rem(30);
    margin-bottom: px2rem(30);
  }

  .tf-title {
    font-size: px2rem(20);
    margin-bottom: px2rem(30);
  }

  .tf-title__second {
    font-size: px2rem(16);
    margin-bottom: px2rem(30);
  }

  .tf-table {
  }

  .tf-pagination {
    display: flex;
    flex-direction: row-reverse;
    margin-top: px2rem(15);
    margin-bottom: px2rem(30);
  }

  .tf-desc {
    font-size: px2rem(14);
    color: $--color-text-regular;
    margin-bottom: 20px;
  }

  .tf-charts {
    display: flex;
    height: px2rem(500);
  }

  .tf-charts__tree {
    flex: 1.5;
    margin-right: px2rem(30);
  }

  .tf-charts__sunburst {
    flex: 1;
  }
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__content {
  border: 1px solid #e4e7ed;
  border-top: none;
  padding: px2rem(30);
}

::v-deep .el-table th.el-table__cell {
  background-color: #f5f8ff;
}

::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 0;
}

::v-deep .el-pagination {
  display: flex;
  align-items: center;
}
</style>
